export default "__VITE_ASSET__DE_O6Wjy__"